module.exports = __webpack_public_path__ + "img/pic-02.02c822ee.png";